import React, {Fragment, useEffect, useState} from "react";
import AdvancedSearch from "./index";
import {useAdvancedSearchBAMutation} from "../../core/api/bermuda-state-api";

export default function AdvancedSearchBA() {

    return <AdvancedSearch useSearchHook={useAdvancedSearchBAMutation} />
}